import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AuthenticationService } from "app/services/authentication.service";
import { Baseservice } from "app/services/baseservice";

@Injectable()
export class CarrierDepotService extends Baseservice {
  constructor(http: HttpClient, authentication: AuthenticationService) {
    super("depot", http, authentication);
  }

  getDepotList(id) {
    return this.getRequest(`${this.url}/by-carrier-id/${id}`);
  }

  addDepot(obj) {
    return this.http.post(`${this.url}`, obj);
  }

  updateDepot(obj) {
    return this.http.put(`${this.url}`,obj);
  }
  getDepotByCarrier(id: number) {
    return this.getRequest(`${this.url}/by-carrier-id/${id}`);
  }
  getDepotDetails(depotId) {
    return this.getRequest(`${this.url}/${depotId}`);
  }

  deleteDepot(depotId) {
    return this.http.delete(`${this.url}/${depotId}`);
  }
}
